export default "__VITE_ASSET__d77f3e90__"